import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox/FormInfobox";
import { Warning } from "@/icons/outlined";

type HelpZeffyCoverFeesInfoboxProps = Omit<FormInfoboxProps, "icon" | "title" | "description"> & {
  organizationName: string;
  bankPaymentMethodLabel: string;
};

export const HelpZeffyCoverFeesInfobox: FC<HelpZeffyCoverFeesInfoboxProps> = ({
  organizationName,
  bankPaymentMethodLabel,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <FormInfobox
      icon={<Warning />}
      variant="emphasis"
      description={t("common", "payment.infoZeffyCoversFees", {
        orgName: organizationName,
        bankPaymentMethod: bankPaymentMethodLabel,
      })}
      {...rest}
    />
  );
};
